import axios from './index';

class PermissionGroupApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `search=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    if (data.booleanFilter) {
      query += `is_active=${data.booleanFilter}&`;
    }
    return axios.get(`${base}${query}`);
  };

  static ListAll = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `search=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`dashboard/module_permission_policy_mapping/${query}`);
  };

  static ListById = (data) => {
    console.log('From Api', data.groupId);
    return axios.get(`dashboard/permission-group-details/${data.groupId}`);
  };

  static Create = (data) => {
    let request = {
      name: data.name,
      permission_policy_id: data.idArray,
    };
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {};
    if (data.name) request.name = data.name;
    if (data.status) request.is_active = data.status === 'true' ? true : false;
    if (data.idArray) request.permission_policy_id = data.idArray;

    return axios.put(`${base}/${data.groupId}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };
}

let base = 'dashboard/permission-group';

export default PermissionGroupApi;
